export default {"src":"/_next/static/image/public/images/ic_rx_mandalay.258d27fc0d973312b91beeb6a767f5c2.svg","height":19,"width":16};